
import Request from './request';
import consts from "@/consts.js";

import store from '../store'
import i18n from '@/i18n';
import snackbar from '@/plugins/snackbar';

async function fetch(data){
    return Request("get","api/supplier-materials/",data)
}

async function fetchOne(id){
    return Request("get","api/supplier-materials/" + id)
}

async function fetchAllForSelect(data) {
    if (!data) data = {};
    data.limit = consts.limitAll; //获取全部
    // data.fieldFilter = ["id","material_id","material.material_code","material.material_name","Standard.name","material.category_code"]; // 仅筛选少许必要字段
    return Request('get', "api/supplier-materials", data, false, false, true);
}

async function fetchAll(data) { 
    if (!data) data = {};
    data.limit = consts.limitAll; //获取全部
    return fetch(data);
}

async function fetchByCategory(data) {
    if (!data) data = {};
    data.limit = consts.limitAll; //获取全部
    return Request('get', "api/supplier-materials/", data);
}

async function batchSave(data) {
    return Request('post', "api/supplier-materials/batch-save", data);
}

// 批量导出
async function exportBatch(data){
    store.dispatch("fullscreenLoading");
    const response = await Request('get', "api/supplier-materials/export", data);
    if (response.data && response.data.status.isOK()) {
        snackbar.info(i18n.t("Export.recordedHint"));
    }
    store.dispatch("fullscreenLoadingStop");
    return response;
}

// 展示分类
async function tree(data) {
    return Request('get', "api/supplier-material-categories/", data);
}

async function modifyMaterialImport(id,file) {// 导入
    var data = new FormData();
    data.append("excel", file);
    data.append("supplier_id", id);
    return Request('post', "api/supplier-materials/modify-material-import", data);
  }

// 模板下载
async function exportTemplate(id){
    store.dispatch("fullscreenLoading");
    const response = await Request('get', "api/supplier-materials/modify-material-export?supplier_id="+id);
    if (response.data && response.data.status.isOK()) {
        snackbar.info(i18n.t("Export.recordedHint"));
    }
    store.dispatch("fullscreenLoadingStop");
    return response;
}
async function fetchProduct(data) {
    return Request('get', "api/purchases/get-add-item-info", data);
}

export default {
    fetch,
    fetchAllForSelect,
    fetchByCategory,
    batchSave,
    exportBatch,
    fetchOne,
    tree,
    modifyMaterialImport,
    exportTemplate,
    fetchAll,
    fetchProduct,
}